import { schema, normalize } from 'normalizr'

// Schemas
import { profileListSchema } from 'modules/profile/models'

// Types
import { EntitiesState, State } from 'types'
import { initialEntities } from 'modules/entities'
import { initialState as authInitialState } from 'modules/auth'

const initialEntitySchema = new schema.Entity('initial', {
  profile: profileListSchema,
})

export const createInitialEntities = (initialStateEntities: EntitiesState): EntitiesState => {
  const { initial, ...entities } = normalize(initialStateEntities, initialEntitySchema).entities // eslint-disable-line
  return {
    ...initialEntities,
    ...entities,
  }
}

export const createInitialState = (data: State, entities: EntitiesState): State => {
  const allData = {
    ...data,
    auth: {
      ...authInitialState,
      ...data.auth,
    },
  }
  return {
    ...allData,
    entities: createInitialEntities(entities),
  }
}
